import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit } from 'redux-form';

import Button from 'components/common/Button';
import CreditCardsForm from './CreditCardsForm';

const styles = theme => ({
  form: {
    overflow: 'hidden',
    padding: '15px 25px 5px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
});

const CreditCardsDialog = props => (
  <Dialog
    open={props.open}
    onClose={props.onClose}
    maxWidth="xs"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Add Credit Card
      </Typography>
    </DialogTitle>
    <DialogContent withScrollbars>
      <CreditCardsForm
        className={props.classes.form}
        {...{ 'User Record Number': props['User Record Number'] }}
        {... props.ID ? { ID: props.ID } : {}}
        {... props.initialValues ? { initialValues: props.initialValues } : {}}
        onSubmitSuccess={props.onClose}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={props.onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => props.dispatch(submit('patientCreditCards'))}
        variant="raised"
        color="primary"
      >
        Done
      </Button>
    </DialogActions>
  </Dialog>
);

CreditCardsDialog.propTypes = {
  open: PropTypes.bool,
  ID: PropTypes.number,
  'User Record Number': PropTypes.number,
  initialValues: PropTypes.shape({
    'Card Number': PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

CreditCardsDialog.defaultProps = {
  open: false,
  ID: null,
  'User Record Number': null,
  initialValues: null,
  onClose: () => {},
};

export default connect()(withStyles(styles)(CreditCardsDialog));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/CreditCards/CreditCardsDialog.js